import { useStores } from './use-stores';

export const useNavigationBlocker = (): ((blocked: boolean) => void) => {
    const { navigationStore } = useStores();
    return (blocked: boolean) => navigationStore.setNavigationBlockState(blocked);
};
